import { BECOME_CLIENT_SURVEY } from '@r1-frontend/survey/context/constants';

import { TButtonQuizProps } from '@r1-frontend/ui-kit/molecules/ButtonQuiz';

export type SurveyName = string;
export type ProviderId = number;
export type SurveyButton = Omit<TButtonQuizProps, 'onClick'>;

export interface SurveyItem {
    name: SurveyName, // человеко-понятное имя опроса

    image: string,
    title: string,
    description: string,
    buttonText: string,

    externalLink: string, // обязательно пока не внедрим бэк
    questions?: unknown[], // опционально пока не внедрим бэк, согласовать контракт
    answers?: unknown[], // опционально пока не внедрим бэк, согласовать контракт

    published?: boolean, // на будущее, для админки
    active?: {
        from?: Date,
        to?: Date,
    },
}

export interface Survey {
    /**
     * Опрос
     */
    survey: SurveyItem,
    /**
     * Тексты в кнопке общего опроса
     */
    button?: SurveyButton,
    /**
     * Список провайдеров, для которых действует опрос (если пустой, то опрос показывается всем)
     */
    providers: ProviderId[],
    /**
     * Список провайдеров, для которых не действует опрос (на случай, если нужно исключить небольшое количество провайдеров)
     */
    excludedProviders: ProviderId[],
    /**
     * Список страниц, для которых действует опрос (если пустой, то опрос показывается всем)
     * Работает только с common-типом, потому что для контекстных не нужен
     */
    pages: string[],
    /**
     * Признак авторизации (если true, то опрос показывается только авторизованным пользователям)
     */
    withAuth: boolean,
}

export interface SurveyStructure {
    /**
     * Общие опросы - отображаются после нажатия на кнопку опроса на странице
     * (при вынесении в админку бэк должен будет сам определять релевантность опроса)
     */
    common: Survey[],
    /**
     * Feature-опросы - узнать мнение пользователей о конкретной функциональности на сайте
     */
    context: Record<SurveyName, Omit<Survey, 'button'>>,
}

export type SurveyType = keyof SurveyStructure;

const surveyStructure: SurveyStructure = {
    common: [{
        survey: {
            name: 'ease of connection',
            image: '',
            title: 'По телефону или онлайн?',
            description: 'Поделитесь своим мнением — как вам удобнее было бы выбрать и подключить тариф.',
            buttonText: '',
            externalLink: 'https://oprosso.ru/p/24ba750a4b0246a1bdbc5d0cb9545a7c',
        },
        button: {
            title: 'Есть минутка?',
            subtitle: 'Нужно ваше мнение',
        },
        providers: [],
        excludedProviders: [41, 556, 8],
        pages: [
            '/',
            '/bundles',
            '/internet',
            '/internet/entertainment',
            '/internet/giga',
            '/internet/giga-movix',
            '/internet/gaming',
            '/internet/gaming-lesta',
            '/internet/lesta-warface',
            '/internet/300-mbit',
            '/internet/500-mbit',
            '/internet/800-mbit',
            '/internet/1000-mbit',
        ],
        withAuth: false,
    }],
    context: {
        [BECOME_CLIENT_SURVEY]: {
            survey: {
                name: BECOME_CLIENT_SURVEY,
                image: '',
                title: 'Почему вы решили оформить заявку по телефону?',
                description: 'Пожалуйста, поделитесь своим мнением и пройдите небольшой опрос.',
                buttonText: '',
                externalLink: 'https://oprosso.ru/p/ef6454f54bcf417a9679dfac7bd0f13e',
            },
            providers: [],
            excludedProviders: [41, 556, 8],
            pages: [],
            withAuth: false,
        },
    },
};

export { surveyStructure };
